export default function Divider(): React.ReactElement {
  return <span className="block border-b border-white w-full mt-6" />
}
